exports = module.exports = require("../../../../_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cube-upload{position:relative}.cube-upload-def{margin-right:-.266667rem}.cube-upload-def .cube-upload-btn,.cube-upload-def .cube-upload-file{float:left;margin:0 .266667rem .266667rem 0}", ""]);

// exports
